export const SelectAccountStyle = theme => ({
    selectAccountContainer: {
        padding: '10px',
        minWidth: '270px',
        maxWidth: '270px'
    }
})